export const EMPLOYABILITY_ENDPOINTS = {
    ADVISORS: "/empleabilidad/advisors",
    ADVISORIES: "/empleabilidad/advisories",
    ADVISORIES_SEARCH: "/empleabilidad/advisories/search",
    ADVISORY_SLOTS: id => `/empleabilidad/advisories/${id}/slots`,
    INACTIVITIES: "/empleabilidad/inactivities",
    RESTORE_INACTIVITY: id => `/empleabilidad/inactivities/${id}/restore`,
    ADMIN_RESERVATIONS_SEARCH: "/empleabilidad/admin/reservations/search",
    ADMIN_RESERVATION_DETAIL: id => `/empleabilidad/admin/reservations/${id}`,
    ADVISOR_CALENDAR: "/empleabilidad/advisor/calendar/search",
    ADVISOR_RESERVATION_DETAIL: id => `/empleabilidad/advisor/reservations/${id}`,
    ADVISOR_ATTENDANCE: id => `/empleabilidad/advisor/reservations/${id}/attendance`,
    ADVISOR_SESSION: id => `/empleabilidad/advisor/reservations/${id}/session`,
    ADVISOR_SESSION_UPDATE: (reservationId, sessionId) =>
        `/empleabilidad/advisor/reservations/${reservationId}/session/${sessionId}`,
    ADVISOR_CLOSE: id => `/empleabilidad/advisor/reservations/${id}/close`,
    REASSIGN_SAME_SLOT: id =>
        `/empleabilidad/reservations/${id}/reassign/search-same-slot`,
    REASSIGN_ALTERNATIVES: id =>
        `/empleabilidad/reservations/${id}/reassign/search-alternatives`,
    REASSIGN: id => `/empleabilidad/reservations/${id}/reassign`,
    REASSIGN_HISTORY: id => `/empleabilidad/reservations/${id}/reassign/history`
};

export const EMPLOYABILITY_RESPONSE_CODES = {
    SUCCESS_STATE: 1
};

export const DAY_IN_MILLISECONDS = 24 * 60 * 60 * 1000;
